import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useLanguage } from "../i18n";

const benefits = [
  {
    title: "One Point of Contact",
    text: "From product selection through delivery and installation coordination, our team keeps the process clear and accountable.",
  },
  {
    title: "Quality and Value",
    text: "We focus on dependable equipment, transparent quotations, and solutions that offer strong long-term value for your laboratory.",
  },
  {
    title: "Solutions for Diverse Labs",
    text: "Our portfolio supports research, quality control, education, and industrial laboratories across a broad range of disciplines.",
  },
  {
    title: "Responsive Service",
    text: "We communicate clearly on availability and delivery, then remain available for technical coordination and after-sales assistance.",
  },
];

export default function AccordionExpandIcon() {
  const { t } = useLanguage();
  const localizedBenefits = benefits.map((benefit, index) => ({ ...benefit, title: t.benefits[index][0], text: t.benefits[index][1] }));
  return (
    <Grid container spacing={2} className="benefits-grid">
      {localizedBenefits.map((benefit, index) => (
        <Grid item xs={12} sm={6} key={benefit.title}>
          <Accordion className="benefit-accordion">
            <AccordionSummary
              expandIcon={<MdKeyboardArrowDown />}
              aria-controls={`benefit-${index}-content`}
              id={`benefit-${index}-header`}
            >
              <Typography variant="h6">{benefit.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{benefit.text}</Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>
      ))}
    </Grid>
  );
}
